import MainLayout from '@/pages/Layout/MainLayout.vue'
const Calendar = () => import('@/pages/calendar/CalendarPage.vue')

export default {
  path: '/calendar',
  component: MainLayout,
  children: [
    {
      path: '',
      name: 'Calendar',
      component: Calendar,
      meta: {
        title: 'Мой календарь',  
      }
    }
  ]
}
